import {useSchedulingAddonsQuery} from "~/lib/Queries";
import CollapsiblePanel from "~/components/CollapsiblePanel";
import Question from "~/components/forms/Question";

const AdminAddonSelection = ({value, onChange, formId, className, eventTypeId}) => {
    const {data, isLoading} = useSchedulingAddonsQuery(eventTypeId, formId)
    const addonQuestions = data?.questions || [];
    value = value || {}

    if (!isLoading && addonQuestions.length === 0) {
        return null;
    }

    return (
        <div>
            <CollapsiblePanel
                title={isLoading ? `Loading add-ons...` : `Add-Ons`}
                className={className}
            >
                <div className="p-4">
                    {addonQuestions.map((q) => (
                        <Question
                            question={q}
                            value={value[q.id]}
                            setValue={(newValue) => {
                                onChange({
                                    ...value,
                                    [q.id]: newValue,
                                })
                            }}
                            id={`answers.${q.id}`}
                        />
                    ))}
                </div>
            </CollapsiblePanel>
        </div>
    )
}

export default AdminAddonSelection;
